var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMobileAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1477_3696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4177 9.98926V12.6768L3.61768 24.3047V9.98926C3.61768 3.53926 5.23018 1.92676 11.6802 1.92676H21.3552C27.8052 1.92676 29.4177 3.53926 29.4177 9.98926Z",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.743 7.57031H13.293",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5178 29.5001C17.8973 29.5001 19.0261 28.3892 19.0261 26.9917C19.0261 25.5942 17.9153 24.4834 16.5178 24.4834C15.1203 24.4834 14.0273 25.5942 14.0273 26.9917C14.0273 28.3892 15.1382 29.5001 16.5178 29.5001Z",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4963 11.7451L29.4179 12.6768L3.61792 24.3047L1.71875 25.1647",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79728 28.4434C3.79728 28.4434 2.72228 34.8218 9.49478 34.8218H23.6848C23.6848 34.8218 29.5256 35.1443 29.5256 27.6372V17.1201",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1477_3696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.465,
    height: 35.5825,
    fill: "white",
    transform: "translate(0.375 0.583008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMobileAppIcon);
export default __webpack_public_path__ + "static/media/no_mobile_app_icon.d290183d943c9133eac5ba4f144740b9.svg";
export { ForwardRef as ReactComponent };